export enum UltimateRemitterSourceEnum {
  updatingImportedPayment = 1,  // It's called from screen where the imported payment is being updated
  others = 2                    // It's called from any other places
}
